/**
 * Detecta los campos numéricos relevantes de un array de registros.
 * Aplica la misma lógica de prioridad que ChartVentasMensual:
 *
 *  1. Si existen "meta" y/o "actual" → modo comparación (2 series)
 *  2. Si existe "value"             → serie única
 *  3. Fallback                      → primer campo numérico encontrado
 *
 * Esto evita que campos auxiliares como "porcentaje" se grafiquen
 * como si fueran series principales.
 *
 * @param data - Registros del endpoint (ya con field mapping)
 * @param groupByField - Campo del eje X (se excluye de la detección)
 */
export function detectValueFields(
  data: Record<string, unknown>[],
  groupByField: string = 'name'
): string[] {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(
      '[KPI Dashboard] detectValueFields activado como fallback heurístico. ' +
      'El widget no tiene field_mapping semántico (category/values) ni schema del endpoint. ' +
      'Configurar field_mapping en la BD o garantizar envelope {data,schema,meta} en el endpoint.'
    );
  }
  if (data.length === 0) return ['value'];

  const sample = data[0];

  const hasMeta = typeof sample.meta === 'number';
  const hasActual = typeof sample.actual === 'number';
  const hasValue = typeof sample.value === 'number';

  // 1. Modo comparación: meta y/o actual
  if (hasMeta || hasActual) {
    return [hasMeta ? 'meta' : null, hasActual ? 'actual' : null].filter(Boolean) as string[];
  }

  // 2. Campo estándar "value"
  if (hasValue) {
    return ['value'];
  }

  // 3. Fallback: primer campo numérico que no sea el eje X
  const firstNumeric = Object.entries(sample)
    .find(([k, v]) => k !== groupByField && typeof v === 'number');

  return firstNumeric ? [firstNumeric[0]] : ['value'];
}
